import { render, staticRenderFns } from "./selfForm.vue?vue&type=template&id=63c66acc&scoped=true&"
import script from "./selfForm.vue?vue&type=script&lang=js&"
export * from "./selfForm.vue?vue&type=script&lang=js&"
import style0 from "./selfForm.vue?vue&type=style&index=0&id=63c66acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c66acc",
  null
  
)

export default component.exports